export default {
  ubuntu: `'Ubuntu', sans-serif`
};
